'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$() {
  this.aLr = null;
  this.aLI = null;
  this.aLu = null;
  this.aLv = false;
  this.aLA = null;
  this.aLB = false;
  this.aLG = null;
  this.aLH = false;
  this.aLs = null;
  this.aLt = false;
  this.aLE = null;
  this.aLF = false;
  this.aLC = null;
  this.aLD = false;
  this.aLw = null;
  this.aLx = false;
  this.aLy = null;
  this.aLz = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ = this;
  this.aLr = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$();
  this.aLI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aLr;
});
$p.eO = (function() {
  return this.aLI;
});
$p.bW = (function() {
  if ((!this.aLv)) {
    this.aLu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aLv = true;
  }
  return this.aLu;
});
$p.b9 = (function() {
  if ((!this.aLB)) {
    this.aLA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aLB = true;
  }
  return this.aLA;
});
$p.b3 = (function() {
  if ((!this.aLH)) {
    this.aLG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aLH = true;
  }
  return this.aLG;
});
$p.aG = (function() {
  if ((!this.aLt)) {
    this.aLs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aLt = true;
  }
  return this.aLs;
});
$p.az = (function() {
  if ((!this.aLF)) {
    this.aLE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aLF = true;
  }
  return this.aLE;
});
$p.aY = (function() {
  if ((!this.aLD)) {
    this.aLC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aLD = true;
  }
  return this.aLC;
});
$p.afe = (function() {
  if ((!this.aLx)) {
    this.aLw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Insurance Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aLx = true;
  }
  return this.aLw;
});
$p.bNy = (function() {
  if ((!this.aLz)) {
    this.aLy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aLz = true;
  }
  return this.aLy;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$, "app.data.data_point_types$package$InsuranceNumberForm$", ({
  FW: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$() {
  this.aLp = null;
  this.aLq = false;
  this.aLn = null;
  this.aLo = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aLq)) {
    this.aLp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aLq = true;
  }
  return this.aLp;
});
$p.bN7 = (function() {
  if ((!this.aLo)) {
    this.aLn = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumberForm$().afe();
    this.aLo = true;
  }
  return this.aLn;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$, "app.data.data_point_types$package$InsuranceNumber$", ({
  FV: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$InsuranceNumber$ };
//# sourceMappingURL=app.data.data_point_types$package$-Insurance-Number$.js.map
